var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "site-header-cart" }, [
    _c(
      "a",
      {
        staticClass: "site-header-cart--button",
        attrs: { href: "#" },
        on: {
          click: function($event) {
            return _vm.toggleOpen()
          }
        }
      },
      [
        _vm._v("\n    " + _vm._s(_vm.buttonText) + "\n    "),
        _c("span", { staticClass: "visually-hidden" }, [
          _vm._v(_vm._s(_vm.buttonA11yText))
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "span",
      {
        staticClass: "site-header-cart-count",
        on: {
          click: function($event) {
            return _vm.toggleOpen()
          }
        }
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(_vm.itemCount) +
            " " +
            _vm._s(_vm.itemCountLabel) +
            "\n  "
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "a",
      { staticClass: "account-link", attrs: { href: _vm.accountLinkUrl } },
      [_vm._v("\n    " + _vm._s(_vm.accountLinkText) + "\n  ")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }